import { useAppStore } from "@/store/useAppStore";
import React from "react";

export const CrowdVotingResults = () => {
  const { crowdData, selectedChallenge } = useAppStore();

  if (!crowdData?.distributions) {
    return null;
  }
  return (
    <div>
      <h4 className="text-lg font-bold mb-4">How the crowd voted:</h4>
      <div className="space-y-3">
        {crowdData.distributions.map((dist: any) => (
          <div
            key={dist.option}
            className="flex justify-between items-center p-3 bg-white/5 rounded-xl"
          >
            <span
              className={
                dist.option === selectedChallenge.correctAnswer
                  ? "text-green-400"
                  : "text-white"
              }
            >
              {dist.option}
            </span>
            <div className="flex items-center space-x-2">
              <div className="w-32 bg-gray-700 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${
                    dist.option === selectedChallenge.correctAnswer
                      ? "bg-green-400"
                      : "bg-gray-400"
                  }`}
                  style={{ width: `${dist.percentage}%` }}
                ></div>
              </div>
              <span className="text-sm">{dist.percentage}%</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 bg-yellow-500/20 rounded-xl border border-yellow-500/30">
        <p className="text-sm text-yellow-300">
          💭 Crowd choice: "{crowdData.crowdChoice}"
          {crowdData.crowdChoice === selectedChallenge.correctAnswer
            ? " ✅ (Correct!)"
            : " ❌ (Wrong!)"}
        </p>
      </div>
    </div>
  );
};
